<div class="zero-state-container">
  <div class="zero-state-img"></div>
  <div class="zero-state-header">Start your chat history</div>
  <div class="zero-state-sub-header">Here you will see all your chats</div>
</div>
